//
// Copyright (c) 2018 Nutanix Inc. All rights reserved.
// Loading component
// Libs
import React from 'react';

// Components
import { FlexLayout, ContainerLayout, Loader } from '@nutanix-ui/prism-reactjs';

export default class BeingBuilt extends React.PureComponent {
    render() {
        return (
            <ContainerLayout padding="10px">
                <FlexLayout
                    padding="20px"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Loader loading={true} tip="Loading IAM UI Application..." />
                </FlexLayout>
            </ContainerLayout>
        );
    }
}
